// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"c79dab06","103":"ef926aa7","425":"ddcabf3a","474":"2903de8c","548":"6ced95f4","692":"7a5a2369","720":"69807e86","934":"25422058"}[chunkId] + ".chunk.js";
};